import { useState } from 'react';
import { Empty } from 'antd-mobile';
import { LeftOutline } from 'antd-mobile-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function SOSHistory() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading] = useState(false);

  return (
    <div className="driver-detail">
      <header className="driver-detail-nav">
        <button
          type="button"
          className="driver-detail-nav-back"
          onClick={() => navigate('/profile')}
          aria-label={t('common.back')}
        >
          <LeftOutline fontSize={22} />
        </button>
        <h1 className="driver-detail-nav-title">{t('sos.historyTitle')}</h1>
        <span className="driver-detail-nav-spacer" aria-hidden="true" />
      </header>

      <div className="driver-section driver-sos-history">
        {loading ? null : (
          <Empty
            description={
              <div className="driver-sos-history__policy">
                <p>{t('sos.historyPolicy1')}</p>
                <p>{t('sos.historyPolicy2')}</p>
                <p>{t('sos.historyPolicy3')}</p>
              </div>
            }
          />
        )}
      </div>
    </div>
  );
}

export default SOSHistory;
